(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Open mega menu on hover
  document.addEventListener('DOMContentLoaded', function() {
    // Find all mega menu details elements
    const megaMenus = document.querySelectorAll('.mega-menu');
    
    megaMenus.forEach(function(menu) {
  const summary = menu.querySelector('summary');
  const content = menu.querySelector('.mega-menu__content');
  let closeTimeout;
  
  if (summary && content) {
    // Get the menu title for accessibility
    const menuTitle = summary.querySelector('span').textContent.trim();

    // Handle both click and keyboard interaction
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = !menu.open;
      menu.open = isOpen;
      summary.setAttribute('aria-expanded', isOpen);
      summary.setAttribute('aria-label', isOpen ? `Close ${menuTitle} menu` : `Expand ${menuTitle} menu`);
    });

    // Handle keyboard events (Enter and Space)
    summary.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const isOpen = !menu.open;
        menu.open = isOpen;
        summary.setAttribute('aria-expanded', isOpen);
        summary.setAttribute('aria-label', isOpen ? `Close ${menuTitle} menu` : `Expand ${menuTitle} menu`);
      }
      if (e.key === 'Escape' && menu.open) {
        menu.open = false;
        summary.setAttribute('aria-expanded', false);
        summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
        summary.focus();
      }
    });
    
    // Add hover to open
    summary.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeout);
      menu.open = true;
      summary.setAttribute('aria-expanded', true);
      summary.setAttribute('aria-label', `Close ${menuTitle} menu`);
    });
    
    // Don't close immediately when leaving summary
    summary.addEventListener('mouseleave', function() {
      closeTimeout = setTimeout(function() {
        menu.open = false;
        summary.setAttribute('aria-expanded', false);
        summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
      }, 500);
    });
    
    // Keep open when hovering over content
    content.addEventListener('mouseenter', function() {
      clearTimeout(closeTimeout);
      menu.open = true;
      summary.setAttribute('aria-expanded', true);
      summary.setAttribute('aria-label', `Close ${menuTitle} menu`);
    });
    
    // Close when leaving content
    content.addEventListener('mouseleave', function() {
      closeTimeout = setTimeout(function() {
        menu.open = false;
        summary.setAttribute('aria-expanded', false);
        summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
      }, 100);
    });

    // Close menu when focus moves outside
    menu.addEventListener('focusout', function(e) {
      setTimeout(() => {
        if (!menu.contains(document.activeElement)) {
          menu.open = false;
          summary.setAttribute('aria-expanded', false);
          summary.setAttribute('aria-label', `Expand ${menuTitle} menu`);
        }
      }, 100);
    });
  }
});
  });

//BACKDROP
document.addEventListener('DOMContentLoaded', function() {
  const backdrop = document.getElementById('mobile-backdrop');
  const menuButton = document.querySelector('.header__icon--menu');
  const searchButtons = document.querySelectorAll('.header__icon--search');
  
  if (!backdrop) return;
  
  function showBackdrop() {
  const backdrop = document.getElementById('mobile-backdrop');
  backdrop.classList.add('active');
}

function hideBackdrop() {
  const backdrop = document.getElementById('mobile-backdrop');
  backdrop.classList.remove('active');
}
  
  // Handle mobile menu
  if (menuButton) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'aria-expanded') {
          const isExpanded = menuButton.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            showBackdrop();
          } else {
            hideBackdrop();
          }
        }
      });
    });
    observer.observe(menuButton, { attributes: true });
  }
  
  // Handle search modals
  searchButtons.forEach(function(searchButton) {
    const searchModal = searchButton.closest('details-modal');
    if (searchModal) {
      const details = searchModal.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function() {
          if (this.open) {
            showBackdrop();
          } else {
            hideBackdrop();
          }
        });
      }
    }
  });
});





// Clean trapFocus override (original working version)
document.addEventListener('DOMContentLoaded', function() {
  
  // Override the global trapFocus function
  if (window.trapFocus) {
    const originalTrapFocus = window.trapFocus;
    window.trapFocus = function(container, elementToFocus) {
      // Store current scroll position
      const currentScroll = window.pageYOffset;
      
      // Call original trapFocus function
      originalTrapFocus.call(this, container, elementToFocus);
      
      // Restore scroll position to prevent jumping
      window.scrollTo(0, currentScroll);
    };
  }
  
  // Override addTrapFocus for mobile menu submenus
  if (window.addTrapFocus) {
    const originalAddTrapFocus = window.addTrapFocus;
    window.addTrapFocus = function() {
      // Store current scroll position
      const currentScroll = window.pageYOffset;
      
      // Call original function
      const result = originalAddTrapFocus.apply(this, arguments);
      
      // Restore scroll position
      window.scrollTo(0, currentScroll);
      
      return result;
    };
  }
  
  // Override removeTrapFocus to prevent scroll when focus returns
  if (window.removeTrapFocus) {
    const originalRemoveTrapFocus = window.removeTrapFocus;
    window.removeTrapFocus = function(elementToFocus) {
      // Store current scroll position
      const currentScroll = window.pageYOffset;
      
      // Call original function
      const result = originalRemoveTrapFocus.call(this, elementToFocus);
      
      // Restore scroll position to prevent jumping
      window.scrollTo(0, currentScroll);
      
      return result;
    };
  }
});





  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      this.checkInitialPosition();

    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    checkInitialPosition() {
  // Wait for header bounds to be calculated
  setTimeout(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.currentScrollTop = scrollTop;
    
    // If we're already scrolled past the header, hide it immediately
    if (scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
  }, 100);
}

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.innerHTML = '<p>Fetching recommendations...</p>';

        fetch(this.dataset.url)
          .then(response => {
            return response.text();
          })
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              const productGrid = recommendations.querySelector('.grid.product-grid, ul[role="list"]');
              
              if (productGrid) {
                const customGrid = document.createElement('div');
                customGrid.className = 'product-recommendations-grid';
                
                const productCards = productGrid.querySelectorAll('.grid__item, li');
                productCards.forEach(card => {
                  customGrid.appendChild(card);
                });
                
                this.innerHTML = '';
                this.appendChild(customGrid);
              } else {
                this.innerHTML = recommendations.innerHTML;
              }
            } else {
              this.innerHTML = '<p>No recommendations available.</p>';
            }

            if (this.querySelector('.grid__item, li')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            this.innerHTML = '<p>Unable to load recommendations: ' + e.message + '</p>';
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
